import { authApi } from '@/api'
import { Roles } from '@/scripts/consts'

export default {
  namespaced: true,

  state: {
    userId: null,
    username: null,
    roles: []
  },

  getters: {
    userId: state => state.userId,
    username: state => state.username,
    allUserRoles: state => state.roles.map(role => role.authority),
    hasAnyRoles: state => !!state.roles.length,
    isAdmin: state => state.roles.some(role => role.authority === Roles.Admin),
    isModerator: state => state.roles.some(role => role.authority === Roles.Moderator),
    isModeratorNir: state => state.roles.some(role => role.authority === Roles.ModeratorNir),
    isModeratorDiss: state => state.roles.some(role => role.authority === Roles.ModeratorDiss),
    isModeratorGrantContest: state => state.roles.some(role => role.authority === Roles.ModeratorGrantContest),
    isModeratorScientificEvent: state => state.roles.some(role => role.authority === Roles.ModeratorScientificEvent),
    isEmployee: state => state.roles.some(role => role.authority === Roles.Employee),
    isEfficiency: state => state.roles.some(role => role.authority === Roles.ViewEfficiencyMetrics),
    isScientific: state => state.roles.some(role => role.authority === Roles.ViewScientificWork),
    isDepartManager: state => state.roles.some(role => role.authority === Roles.DepartManager),
    isAuditor: state => state.roles.some(role => role.authority === Roles.Auditor),
    isSomeModerator: (state, getters) =>
      getters.isModerator ||
      getters.isModeratorNir ||
      getters.isModeratorDiss ||
      getters.isModeratorGrantContest ||
      getters.isModeratorScientificEvent
  },

  mutations: {
    setUserParams(state, payload) {
      state.userId = payload.id
      state.username = payload.username
      state.roles = payload.authorities
    },

    clearUserParams(state) {
      state.userId = null
      state.username = null
      state.roles = []
    }
  },

  actions: {
    async login({ commit }, payload) {
      const formData = new FormData()
      formData.append('username', payload.username)
      formData.append('password', payload.password)

      const data = await authApi.login(formData)
      commit('setUserParams', data)
      return data
    },

    async getCurrent({ state, commit }) {
      try {
        if (!(state.userId && state.username && state.roles.length)) {
          const data = await authApi.getCurrent()
          commit('setUserParams', data)
        }
      } catch (e) {
        console.log(e)
      }
    },

    async logout({ commit }) {
      await authApi.logout()
      commit('clearUserParams')
    }
  }
}
